export default __webpack_public_path__ + "static/media/pic3.c71a1c89.jpg";